interface OwnershipDisplayNameSource {
  firstName: string;
  lastName: string;
  userName: string;
}

/**
 * "First Last", falling back to the userName when both parts are blank. Shared by the ownership picker
 * (`useOwnershipOptions`) and the project-nodes grid's Ownership column so the same user can't be shown
 * under two different labels depending on which one renders it.
 */
export function getOwnershipDisplayName({ firstName, lastName, userName }: OwnershipDisplayNameSource): string {
  return `${firstName} ${lastName}`.trim() || userName;
}
